import { Link } from '@inertiajs/react'
import { cn } from '@/utils/cn'
import { focusRing } from '@/components/ui/buttonStyles'

interface Crumb {
  label: string
  href: string
}

/** The way back up from a page below a section: Users / someone@example.com. */
export function AdminBreadcrumb({ trail }: { trail: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-2">
      <ol className="flex flex-wrap items-center gap-x-2 font-serif text-sm text-muted">
        {trail.map((crumb, i) => (
          <li key={crumb.href} className="flex min-w-0 items-center gap-2">
            {i > 0 && <span aria-hidden="true">/</span>}
            <Link
              href={crumb.href}
              className={cn('inline-flex min-h-11 items-center break-all rounded transition-colors duration-200 hover:text-accent', focusRing)}
            >
              {crumb.label}
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  )
}
